import { RemoteRoundResultSubmitter } from './remote-round-result-submitter';
import { RoundResultSubmitter } from './round-result-submitter';

export abstract class RoundParams {
  public readonly roundResultSubmitter: RoundResultSubmitter;

  constructor(roundResultSubmitter: RoundResultSubmitter) {
    this.roundResultSubmitter = roundResultSubmitter;
  }
}

export abstract class RemoteRoundParams extends RoundParams {
  constructor(remoteRoundResultSubmitter: RemoteRoundResultSubmitter) {
    super(remoteRoundResultSubmitter);
  }
}

export abstract class LocalRoundParams extends RoundParams {
  constructor(localRoundResultSubmitter: RoundResultSubmitter) {
    super(localRoundResultSubmitter);
  }
}
